<rt-dialog-header [heading]="'tlc.positions.confirm_position_change_dialog.header' | translate" />

<rt-dialog-body>
  <div class="members-list">
    @for (member of members(); track member.guid) {
      <div class="member-card">
        <div class="member-header">
          <rt-avatar
            class="member-avatar"
            [type]="!!member.avatarThumbUrl ? 'image' : 'initials'"
            [imageSrc]="member.avatarThumbUrl"
            [fullName]="member.fullName"
            context="admin"
          />
          <span class="member-name"
            ><rt-truncate>{{ member.fullName }}</rt-truncate></span
          >
        </div>
        <rt-divider class="member-divider" />
        <div class="positions-change">
          <div class="position-column">
            <span class="position-label">{{
              'tlc.positions.confirm_position_change_dialog.current_position' | translate
            }}</span>
            <span class="position-name">
              @if (member.currentPosition) {
                {{ member.currentPosition.name }}
              } @else {
                {{ 'tlc.positions.confirm_position_change_dialog.no_position' | translate }}
              }
            </span>
          </div>
          <rt-icon class="positions-arrow" name="arrow-forward" />
          <div class="position-column">
            <span class="position-label">{{
              'tlc.positions.confirm_position_change_dialog.new_position' | translate
            }}</span>
            <span class="position-name">{{ targetPositionName() }}</span>
          </div>
        </div>
      </div>
    }
  </div>

  @if (allHaveCurrentPosition()) {
    <div class="history-card">
      <rt-checkbox
        [checked]="addToHistory()"
        (valueChange)="toggleHistory(!!$event)"
        [hasMargin]="false"
        [wrapLabel]="true"
      >
        <span class="history-label">{{
          'tlc.positions.confirm_position_change_dialog.add_to_history.label' | translate
        }}</span>
        <span class="history-subtitle">
          @if (singleCurrentPositionName(); as positionName) {
            {{
              'tlc.positions.confirm_position_change_dialog.add_to_history.subtitle'
                | translate: { position: positionName }
            }}
          } @else {
            {{
              'tlc.positions.confirm_position_change_dialog.add_to_history.subtitle_bulk'
                | translate
            }}
          }
        </span>
      </rt-checkbox>
    </div>
  }

  @if (isCorrection()) {
    <rt-infobox
      type="information"
      iconName="info-outline"
      [isDismissible]="false"
      [hasDotDivider]="false"
    >
      <div class="correction-content">
        <span>{{
          'tlc.positions.confirm_position_change_dialog.correction_infobox.message' | translate
        }}</span>
        @if (singleCurrentPositionName(); as positionName) {
          <div class="correction-positions">
            <span class="correction-old">{{ positionName }}</span>
            <span class="correction-new">{{ targetPositionName() }}</span>
          </div>
        }
      </div>
    </rt-infobox>
  }

  @if (!isCorrection()) {
    <div class="date-card">
      <span class="date-title">{{
        'tlc.positions.confirm_position_change_dialog.effective_date.title' | translate
      }}</span>
      <span class="date-subtitle">{{
        'tlc.positions.confirm_position_change_dialog.effective_date.subtitle' | translate
      }}</span>

      <rt-input
        #dateOrigin="rtOverlayOrigin"
        rt-overlay-origin
        class="date-input"
        variant="rounded"
        [value]="
          effectiveDateLabel() ??
          ('tlc.positions.confirm_position_change_dialog.effective_date.today' | translate)
        "
        [hasDropdownIndicator]="true"
        [readOnly]="true"
        (click)="dateDropdown.open = !dateDropdown.open"
      >
        <rt-icon prefix name="calendar-blank" />
      </rt-input>

      <ng-template
        #dateDropdown="rtConnectedOverlay"
        [origin]="dateOrigin"
        (backdropClick)="dateDropdown.open = false"
        rt-connected-overlay
        hasBackdrop
      >
        <rt-dropdown (click)="$event.stopPropagation()">
          <rt-dropdown-header [fullWidthTitle]="true">{{
            'tlc.positions.confirm_position_change_dialog.effective_date.subtitle' | translate
          }}</rt-dropdown-header>
          <rt-date-picker
            [formControl]="effectiveDateControl"
            direction="today-future"
            (valueChanged)="dateDropdown.open = false"
          />
        </rt-dropdown>
      </ng-template>
    </div>
  }

  @if (showFutureInfobox()) {
    <rt-infobox
      type="information"
      iconName="calendar-today"
      [heading]="'tlc.positions.confirm_position_change_dialog.future_infobox.heading' | translate"
      [subheading]="
        'tlc.positions.confirm_position_change_dialog.future_infobox.subheading' | translate
      "
      [isDismissible]="false"
      [hasDotDivider]="false"
    />
  }
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" (click)="confirm()">
    {{ 'tlc.positions.confirm_position_change_dialog.save_button' | translate }}
  </rt-button>
</rt-dialog-footer>
